// @ts-nocheck
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import {
  FETCH_PARTIAL_EVENTS_SUCCESS,
  FETCH_PARTIAL_EVENTS_FAILURE,
  FETCH_PARTIAL_EVENTS_REQUEST,
} from "../constants/partialRequests";

const initialState = {
  partialEvents: [],
  searchString: "",
  currentPage: 1,
  totalPages: null,
  totalEvents: null,
  ucLoading: false,
  isLoading: true,
  searchBy: [],
  rowsPerPage: rowsPerPageInit,
  filtersDate: null,
};

const partialEventsReducer = (state = initialState, action) => {
  switch (action?.type) {
    // get all approved events
    case FETCH_PARTIAL_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload?.searchString,
        searchBy: action?.payload?.searchBy,
        rowsPerPage: action?.payload?.rowsPerPage,
        filtersDate: action?.payload?.filtersDate,
      };

    case FETCH_PARTIAL_EVENTS_SUCCESS:
      return {
        ...state,
        partialEvents: action.payload?.events,
        currentPage: action.payload?.currentPage,
        totalPages: action.payload?.totalPages,
        totalEvents: action.payload?.totalEvents,
        isLoading: false,
      };

    case FETCH_PARTIAL_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // default case
    default:
      return state;
  }
};

export default partialEventsReducer;
export { initialState };